import { render, staticRenderFns } from "./Performances.vue?vue&type=template&id=4a85422f&scoped=true"
import script from "./Performances.vue?vue&type=script&lang=js"
export * from "./Performances.vue?vue&type=script&lang=js"
import style0 from "./Performances.vue?vue&type=style&index=0&id=4a85422f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a85422f",
  null
  
)

export default component.exports